import { QueryClient, QueryKey } from "@tanstack/react-query";

// One in-memory cache per app instance, shared across routes.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, staleTime: Infinity, gcTime: 15 * 60_000 },
    mutations: { retry: false },
  },
});

let session = 0;
export const getQuerySession = () => session;

export const apiQueryKey = (apiName: string, firebaseUid: string | null, queryKey: QueryKey, request: unknown) =>
  [apiName, { session: getQuerySession(), firebaseUid }, ...queryKey, request] as const;

export function clearQuerySession() {
  session += 1;
  queryClient.clear();
}
